<woa-modal-page-layout [closeButtonAlignment]="containerComponentRef.instance.pageSpec.geometry.alignment"
                       [backgroundColorPair]="'panel'">
    <div class="nav-menu">
        @if (configurationModel.app() && (configurationModel.allowMemberLogin() || configurationModel.isWaiterActor())) {
            <div class="nav-menu-identity">
                @if (configurationModel.allowMemberLogin() && profileName()) {
                    <div class="nav-menu-identity-greeting" [class.standalone]="identityModel.isGuestUser()">
                        {{ 'woa.heading.nav-menu.greeting' | translate: {name: profileName()} }}
                    </div>
                }
                @if (showWaiterName()) {
                    <div class="nav-menu-identity-greeting">
                        {{ 'woa.heading.nav-menu.greeting' | translate: {name: identityModel.waiterName()} }}
                    </div>
                }
                @if (configurationModel.isWaiterActor() && !showWaiterName()) {
                    <div class="nav-menu-identity-greeting standalone">
                        {{ configurationModel.appName() }}
                    </div>
                }
                @if (configurationModel.isWaiterActor() && (showWaiterName() || appDeviceService.isDevice())) {
                    <div class="nav-menu-identity-secondary">
                        @if (showWaiterName()) {
                            <div class="nav-menu-identity-secondary-segment"
                                [class.standalone]="!appDeviceService.isDevice()">
                                {{ configurationModel.appName() }}
                            </div>
                        }
                        @if (appDeviceService.isDevice()) {
                            <div class="nav-menu-identity-secondary-segment"
                                 [class.standalone]="!showWaiterName()">{{ appDeviceService.deviceName() }}
                            </div>
                        }
                    </div>
                }
                @if (configurationModel.isConsumerActor() && identityModel.isGuestUser()) {
                    <woa-button id="login-button" class="nav-menu-identity-button"
                                [ngClass]="{'full-width': !configurationModel.supportsRegistration()}"
                                [prominence]="configurationModel.supportsRegistration() ? ButtonProminence.LOW : ButtonProminence.HIGH"
                                [label]="'woa.button.nav-menu.login'" (onActivate)="login()"></woa-button>
                }
                @if (configurationModel.isConsumerActor() && identityModel.isGuestUser() && configurationModel.supportsRegistration()) {
                    <woa-button id="register-button" class="nav-menu-identity-button"
                                [label]="'woa.button.nav-menu.register'" (onActivate)="register()"></woa-button>
                }
                @if ((configurationModel.isConsumerActor() && !identityModel.isGuestUser()) || showWaiterName()) {
                    <woa-button id="logout-button" class="nav-menu-identity-button"
                                [prominence]="ButtonProminence.LOW"
                                [connotation]="ButtonConnotation.DISSUASIVE"
                                [label]="'woa.button.nav-menu.logout'" (onActivate)="logout()"></woa-button>
                }
                @if (showWaiterName()) {
                    <woa-button id="change-waiter-name-button" class="nav-menu-identity-button"
                                [prominence]="ButtonProminence.LOW"
                                [label]="'woa.button.nav-menu.changeWaiterName'"
                                (onActivate)="changeWaiterName()"></woa-button>
                }
            </div>
        }
        <div class="nav-menu-options">
            @if (configurationModel.isConsumerActor() && (!identityModel.isGuestUser() || customerDetails?.populated)) {
                <div woa-activatable (onActivate)="profile()"
                    id="profile-option" class="nav-menu-options-option">
                    <div class="nav-menu-options-option-label">
                        {{ 'woa.label.nav-menu.profile' | translate }}
                    </div>
                    <woa-icon-button class="nav-menu-options-option-button" [type]="IconButtonType.FORWARD"
                                     (onActivate)="profile()"></woa-icon-button>
                </div>
            }
            @if (configurationModel.isConsumerActor() && !identityModel.isGuestUser() && !configurationModel.app().integratedLoyalty) {
                <div woa-activatable (onActivate)="changePassword()"
                    id="password-option" class="nav-menu-options-option">
                    <div class="nav-menu-options-option-label">
                        {{ 'woa.label.nav-menu.password' | translate }}
                    </div>
                    <woa-icon-button class="nav-menu-options-option-button" [type]="IconButtonType.FORWARD"
                                     (onActivate)="changePassword()"></woa-icon-button>
                </div>
            }
            @if (configurationModel.isConsumerActor() && !identityModel.isGuestUser()) {
                <div woa-activatable (onActivate)="loyaltyCards()"
                    id="cards-option" class="nav-menu-options-option">
                    <div class="nav-menu-options-option-label">
                        {{ 'woa.label.nav-menu.loyalty-cards' | translate }}
                    </div>
                    <woa-icon-button class="nav-menu-options-option-button" [type]="IconButtonType.FORWARD"
                                     (onActivate)="loyaltyCards()"></woa-icon-button>
                </div>
            }
            @if (configurationModel.isConsumerActor()) {
                <div woa-activatable (onActivate)="orders()"
                    id="orders-option" class="nav-menu-options-option">
                    <div class="nav-menu-options-option-label">
                        {{ 'woa.label.nav-menu.orders' | translate }}
                    </div>
                    <woa-icon-button class="nav-menu-options-option-button" [type]="IconButtonType.FORWARD"
                                     (onActivate)="orders()"></woa-icon-button>
                </div>
            }
            <div woa-activatable (onActivate)="deals()"
                 id="deals-option" class="nav-menu-options-option">
                <div class="nav-menu-options-option-label">
                    {{ 'woa.label.nav-menu.deals' | translate }}
                </div>
                <woa-icon-button class="nav-menu-options-option-button" [type]="IconButtonType.FORWARD"
                                 (onActivate)="deals()"></woa-icon-button>
            </div>
            @if (configurationModel.isConsumerActor() && orderingContextModel.canChangeStore() && orderingContextModel.stores()?.length) {
                <div woa-activatable (onActivate)="stores()"
                    id="stores-option" class="nav-menu-options-option">
                    <div class="nav-menu-options-option-label">
                        {{ 'woa.label.nav-menu.stores' | translate }}
                    </div>
                    <woa-icon-button class="nav-menu-options-option-button" [type]="IconButtonType.FORWARD"
                                     (onActivate)="stores()"></woa-icon-button>
                </div>
            }
            @if (configurationModel.isConsumerActor() && (orderingContextModel.currentStore() || orderingContextModel.singleStoreLocation())) {
                <div woa-activatable (onActivate)="currentStore()"
                    id="current-store-option" class="nav-menu-options-option">
                    <div class="nav-menu-options-option-label">
                        {{ currentStoreLabel() | translate:{'storeName': orderingContextModel.singleStoreLocation() ? orderingContextModel.singleStoreLocation().storeName : orderingContextModel.currentStore().collectiveStoreName} }}
                    </div>
                    <woa-icon-button class="nav-menu-options-option-button" [type]="IconButtonType.FORWARD"
                                     (onActivate)="currentStore()"></woa-icon-button>
                </div>
            }
            @if (showFeedback()) {
                <div woa-activatable (onActivate)="feedback()"
                    id="feedback-option" class="nav-menu-options-option">
                    <div class="nav-menu-options-option-label">
                        {{ 'woa.label.nav-menu.feedback' | translate }}
                    </div>
                    <woa-icon-button class="nav-menu-options-option-button" [type]="IconButtonType.FORWARD"
                                     (onActivate)="feedback()"></woa-icon-button>
                </div>
            }
            @if (appDeviceService.isAvailable()) {
                <div woa-activatable (onActivate)="appDeviceReload()"
                    id="app-device-refresh" class="nav-menu-options-option">
                    <div class="nav-menu-options-option-label">
                        {{ 'woa.label.nav-menu.app-device-reload' | translate }}
                    </div>
                </div>
            }
            @if (appDeviceService.isAvailable()) {
                <div woa-activatable (onActivate)="exitToAppDevice()"
                    id="app-device-exit" class="nav-menu-options-option">
                    <div class="nav-menu-options-option-label">
                        {{ 'woa.label.nav-menu.app-device-exit' | translate }}
                    </div>
                    <woa-icon-button class="nav-menu-options-option-button" [type]="IconButtonType.FORWARD"
                                     (onActivate)="exitToAppDevice()"></woa-icon-button>
                </div>
            }
            @if (appDeviceService.isAvailable()) {
                <div woa-activatable (onActivate)="appDeviceStatus()"
                    id="app-device-status" class="nav-menu-options-option">
                    <div class="nav-menu-options-option-label">
                        {{ 'woa.label.nav-menu.app-device-status' | translate }}
                    </div>
                    <woa-icon-button class="nav-menu-options-option-button" [type]="IconButtonType.FORWARD"
                                     (onActivate)="appDeviceStatus()"></woa-icon-button>
                </div>
            }
            @if (configurationModel.showExitButton()) {
                <div woa-activatable (onActivate)="exit()"
                    id="exit-option" class="nav-menu-options-option">
                    <div class="nav-menu-options-option-label">
                        {{ 'woa.label.nav-menu.exit' | translate }}
                    </div>
                </div>
            }
        </div>
        <div class="nav-menu-footer">
            <div class="nav-menu-footer-logo">
                <woa-chewzie-attribution></woa-chewzie-attribution>
            </div>
            <woa-legal-panel class="nav-menu-footer-legal" [messageSet]="'nav-menu'"
                             (onLinkOpened)="dismiss()"></woa-legal-panel>
            @if (configurationModel.timeTestMode()) {
                <div class="nav-menu-footer-info">
                    {{ formatDateTimeForDisplay(configurationModel.now) }}
                </div>
            }
            @if (version() !== '0.0.0') {
                <div class="nav-menu-footer-info">
                    {{ version() }}
                </div>
            }
        </div>
    </div>
</woa-modal-page-layout>
